import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ApiService } from '../../../Services/api.service';
import { DataGridComponent } from '../../../Common/Components/data-grid/data-grid.component';
import { AddLotSizeComponent } from './add-lot-size/add-lot-size.component';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'app-lot-size-crtiteria',
  standalone: true,
  imports: [NzButtonModule, NzDrawerModule, NzSelectModule, CommonModule, FormsModule,NzTagModule, ReactiveFormsModule, AddLotSizeComponent, DataGridComponent],
  templateUrl: './lot-size-crtiteria.component.html',
  styleUrl: './lot-size-crtiteria.component.scss'
})
export class LotSizeCrtiteriaComponent implements OnInit {
  constructor(private apiService: ApiService) {
  }

  @Input() catalogId: string = '';
  selectedLot: string = '';
  assoctLots: any = [];
  inValidSearch: boolean = false;
  linkDrawer: boolean = false;
  assctLotSizes: any;
  lotSizeColumns = [
    {
      field: 'dim1',
      header: 'Size 1',
      compare: (a: any, b: any) => (a.dim1 ?? "").localeCompare((b.dim1 ?? ""))
    },
    {
      field: 'dim2',
      header: 'Size 2',
      compare: (a: any, b: any) => (a.dim2 ?? "").localeCompare((b.dim2 ?? ""))
    },

    {
      field: '',
      header: 'Action',
      icons: ['delete'],
      type: 'icon',
      showIcons: true
    }];

  ngOnInit(): void {
    this.getAssociatedLots();
  }

 onSearch(value: string): void {
  const upperValue = value.toUpperCase();
}
  getAssociatedLots() {
    this.apiService.getAssociatedLot(this.catalogId).subscribe(res => {
      this.assoctLots = res;
    })
  }

  searchLotSizes() {
    if (!this.selectedLot) {
      this.inValidSearch = true;
      return
    }
    this.inValidSearch = false;
    this.apiService.getAssociatedLotSizes(this.catalogId, this.selectedLot).subscribe(res => {
      this.assctLotSizes = res;
    })
  }

  deleteRow(data: any) {
    this.apiService.updateLotSizes(this.catalogId, this.selectedLot, 'DELETE', [data]).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      this.searchLotSizes();
       this.getAssociatedLots();
    },err=>{
       this.apiService.createNotification('error', err?.error?.message);
    })
  }

  addLot(data: any) {
    this.apiService.updateLotSizes(this.catalogId, this.selectedLot, 'ADD', data).subscribe(res => {
      this.linkDrawer = false;
      this.apiService.createNotification('success', res?.message);
      this.searchLotSizes();
      this.getAssociatedLots();
    },err=>{
       this.apiService.createNotification('error', err?.error?.message);
    })
  }
}
